import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions: FC = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100vw", minHeight: "76vh" }}>
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "60vw" }}>
                <Typography variant="h3" align="center" mb={2}>Terms and Conditions</Typography>
                <Typography variant="body1" align="center">
                    In the future you'll find our terms & conditions here. For now, we're still working on it.
                </Typography>
                <Button
                    sx={{ mt: 3 }}
                    variant="contained"
                    onClick={() => navigate("/register")}>
                    Go back to registration
                </Button>
            </Box>
        </Box>
    );
};

export default TermsAndConditions;